import Vue from 'vue';

import store from '../store/index';
// 网络图片
function ftpUrl(url){
	if (url.startsWith('http://') || url.startsWith('https://')) return url;
	return baseUrl.imageUrl + url;
}
Vue.prototype.$ftpUrl= ftpUrl;

//url地址
function Url(url){
	if (url.startsWith('http://') || url.startsWith('https://')) return url;
	return baseUrl.url + url;
}
Vue.prototype.$Url= Url;


//url地址
function carType(e){
	return e==1?'小车':e==2?'客车':e==3?'货车':e==4?'摩托车':''
}
Vue.prototype.$CarType= carType;


//url地址
function subjectType(e){
	return e==1?'科目一':e==4?'科目四':e==5?'满分学习':e==6?'注销恢复':''
}
Vue.prototype.$SubjectType= subjectType;

// go
function go(url,item){
	this.$router.push({
		name:url
	})
	
	store.commit('ADD_PAGEPARAMS',item)
	
}
Vue.prototype.$Go= go;


// WEBPACK FOOTER //
// ./src/utils/common.js